import React, { useState } from "react"
import MetaTags from 'react-meta-tags';

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

import { Container, Row, Col, CardBody, Card, Button, Alert } from "reactstrap"

// import images
import profileImg from "../../assets/images/profile-img.png"
import logoImg from "assets/images/logo/cargills_GO.png"
//import logoImg from "assets/images/logo/mySky_GO.png"
import avatar from "../../assets/images/users/avatar-1.jpg"
import { useHistory } from "react-router-dom";

//check active client
import Config, { ActiveClient } from "../../config";


const LockScreen = () => {

  const obj = JSON.parse(localStorage.getItem("authUser"))
  const [strUsername, setUsername] = useState(obj[2])
  const [strPassword, setPassword] = useState('')
  const [selectedloc, setselectedloc] = useState(obj[3])
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')

  const history = useHistory(); // Create a history object

  /* Changed by : Madhura Liyanage
    Changed On : 30/11/2022
    Reason : Changed all image storage/accessing location to media server
  */
  //---------Beginning of change ---------------------------------------------------------------------------------------------------------------
 
  const [usrImg, setusrImg] = useState(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);
  //---------End of change ---------------------------------------------------------------------------------------------------------------

  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    //debugger;
    //dispatch(loginUser(values, props.history))    
    if (selectedloc == null) {
      setAlertColor("danger")
      setAlertMsg("Please select Location !")
      setShow(true)
      return
    }
    const Logindet = { strUsername, strPassword }
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);

    var raw = JSON.stringify({
      "strUsername": strUsername,
      "strPassword": strPassword,
      "strLocation": selectedloc
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(`${ApiURL}login`, requestOptions)
      .then(response => {
        console.log(response)
        if (response.status == "200") {
          response.json()
            .then(responseData => {
              localStorage.removeItem("authPark")
              history.push("/");
              return;
            })
        } else if (response.status == "403") {
          setAlertColor("danger")
          setAlertMsg("Invalid Access to Location !")
          setShow(true)

        } else if (response.status == "404") {
          setAlertColor("danger")
          setAlertMsg("Invalid Login Details !")
          setShow(true)

        } else if (response.status == "400") {
          setAlertColor("danger")
          setAlertMsg("Unexpected error!")
          setShow(true)
        }

      })
      .catch(error => console.log('error', error));

  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Lock Screen </title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            {show ? (
              <Alert color={AlertColor} role="alert">
                {AlertMsg}
              </Alert>
            ) : null}
            <Col md="8" lg="6" xl="5">
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs="7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Lock screen</h5>
                        <p>Enter your password to unlock the screen!</p>
                      </div>
                    </Col>
                    <Col xs="5" className="align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm className="form-horizontal">
                      <div className="user-thumb text-center mb-4">
                        <img
                          src={usrImg}
                          className="rounded-circle img-thumbnail avatar-md"
                          alt="thumbnail"
                        />
                        <h5 className="font-size-15 mt-3">{obj[0]}</h5>
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          required
                          value={strPassword}
                          onChange={(e) => {
                            setPassword(e.target.value)
                          }}
                          placeholder="Enter Password"
                        />
                      </div>

                      <div className="text-end">
                        <Col xs="12" className="text-end">
                          <Button
                            color="primary"
                            className=" w-md "
                            type="button"
                            onClick={handleValidSubmit}
                          >
                            Unlock
                          </Button>
                        </Col>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Not you ? return{" "}
                  <Link
                    to="/login"
                    className="fw-medium text-primary"
                  >
                    {" "}
                    Sign In{" "}
                  </Link>{" "}
                </p>
                <p>
                © {new Date().getFullYear()} <a href={Config[Config.ActiveClient].webUrl}>{Config[Config.ActiveClient].fullName}</a>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default LockScreen
